module.exports = require("app-lib-nobuild");